import { StateSchema } from 'app/config/storeConfig/types';

export const getOutlinedCard = (state: StateSchema): Nullable<string> => state.warehouseMap.outlinedWarehouseCard;
